/** Coordinates shared by movable presentation objects and future renderers. */
export interface PresentationObjectPosition {
  readonly x: number;
  readonly y: number;
}

export function clampPresentationObjectPosition(
  x: number,
  y: number,
  viewportWidth: number,
  viewportHeight: number,
  objectWidth: number,
  objectHeight: number,
): PresentationObjectPosition {
  return {
    x: Math.max(0, Math.min(x, Math.max(0, viewportWidth - objectWidth))),
    y: Math.max(0, Math.min(y, Math.max(0, viewportHeight - objectHeight))),
  };
}
